import axios from "axios";
import { api } from "./api_route";

export const createNoticeTemplate = async (formData) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/create`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllNoticeTemplates = async (params) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/getAll`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getNoticeTemplatesByOrganization = async (
  OrgID,
  caseType,
  caseSubType,
  noticeCategory,
) => {
  try {
    const response = await axios.get(
      `${api}/noticeTemplates/getNoticeTemplatesByOrganization`,
      { params: { OrgID, caseType, caseSubType, noticeCategory } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getNoticeTemplateById = async (Id) => {
  try {
    const response = await axios.get(`${api}/noticeTemplates/getById/${Id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateNoticeTemplate = async (Id, formData) => {
  try {
    const response = await axios.put(
      `${api}/noticeTemplates/update/${Id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNoticeTemplate = async (id) => {
  try {
    const response = await axios.delete(`${api}/noticeTemplates/delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const DownloadNoticeTemplate = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/noticeTemplateDocuments/${values.alterFileName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};

export const convertDocxToPdf = async (docxBlob, filename) => {
  try {
    const formData = new FormData();
    const file = new File([docxBlob], filename || "document.docx", {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });
    formData.append("file", file);

    const response = await axios.post(`${api}/convert/docx-to-pdf`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    });

    return {
      blob: response.data,
      filename: response.headers["x-filename"] || "notice.pdf",
    };
  } catch (error) {
    throw error;
  }
};

export const evaluateConditions = async (templateId, agreementNumbers) => {
  try {
    const response = await axios.post(
      `${api}/noticeTemplates/evaluateConditions`,
      { templateId, agreementNumbers },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const convertZipDocxToPdf = async (zipFile) => {
  try {
    const formData = new FormData();
    formData.append("file", zipFile);

    const response = await axios.post(
      `${api}/noticeTemplates/convert/zip-docx-to-pdf`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      },
    );

    return {
      blob: response.data,
      filename: response.headers["x-filename"] || "converted.zip",
    };
  } catch (error) {
    throw error;
  }
};

export const generateNoticesFromTemplate = async (formData) => {
  try {
    const url = `${api}/noticeTemplates/noticeGeneration`;
    const response = await axios.post(url, formData);

    const {
      success,
      fileName,
      contentType,
      blob: base64Blob,
      skipped,
      message,
      excludedAgreements,
      withGuarantorAgreements,
      withoutGuarantorAgreements,
      satisfiedAgreements,
      unsatisfiedAgreements,
      previewData,
    } = response.data;

    let blob = null;
    if (base64Blob && success) {
      const byteCharacters = atob(base64Blob);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray], {
        type:
          contentType ||
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
    }

    return {
      success,
      blob,
      filename: fileName,
      contentType,
      skipped: skipped || [],
      excludedAgreements: excludedAgreements || [],
      withGuarantorAgreements: withGuarantorAgreements || [],
      withoutGuarantorAgreements: withoutGuarantorAgreements || [],
      satisfiedAgreements: satisfiedAgreements || [],
      unsatisfiedAgreements: unsatisfiedAgreements || [],
      message,
      previewData: previewData || null,
    };
  } catch (error) {
    throw error;
  }
};
